/**
 * @fileoverview gRPC-Web generated client stub for Rag
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.33.2
// source: ragService.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.Rag = require('./ragService_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.Rag.RagServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.Rag.RagServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagBootstrapRequest,
 *   !proto.Rag.RagBootstrapResponse>}
 */
const methodDescriptor_RagService_ragBootstrap = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragBootstrap',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagBootstrapRequest,
  proto.Rag.RagBootstrapResponse,
  /**
   * @param {!proto.Rag.RagBootstrapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagBootstrapResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagBootstrapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagBootstrapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagBootstrapResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragBootstrap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragBootstrap',
      request,
      metadata || {},
      methodDescriptor_RagService_ragBootstrap,
      callback);
};


/**
 * @param {!proto.Rag.RagBootstrapRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagBootstrapResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragBootstrap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragBootstrap',
      request,
      metadata || {},
      methodDescriptor_RagService_ragBootstrap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBasePageRequest,
 *   !proto.Rag.RagKnowledgeBasePageResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBasePage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBasePage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBasePageRequest,
  proto.Rag.RagKnowledgeBasePageResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBasePageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBasePageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBasePageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBasePageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBasePageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBasePage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBasePage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBasePage,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBasePageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBasePageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBasePage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBasePage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBasePage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseCreateRequest,
 *   !proto.Rag.RagKnowledgeBaseCreateResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseCreate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseCreate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseCreateRequest,
  proto.Rag.RagKnowledgeBaseCreateResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseCreateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseCreateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseCreateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseCreateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseCreate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseCreate,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseCreateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseCreate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseCreate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseUploadRequest,
 *   !proto.Rag.RagKnowledgeBaseUploadResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseUpload = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseUpload',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseUploadRequest,
  proto.Rag.RagKnowledgeBaseUploadResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseUploadResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseUpload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseUpload',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseUpload,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseUploadResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseUpload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseUpload',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseUpload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseDeleteRequest,
 *   !proto.Rag.RagKnowledgeBaseDeleteResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseDelete = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseDelete',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseDeleteRequest,
  proto.Rag.RagKnowledgeBaseDeleteResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseDeleteResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseDeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseDeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDelete,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseDeleteResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseDetailRequest,
 *   !proto.Rag.RagKnowledgeBaseDetailResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseDetail = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseDetail',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseDetailRequest,
  proto.Rag.RagKnowledgeBaseDetailResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseDetailResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDetail',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDetail,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseDetailResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDetail',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseUpdateRequest,
 *   !proto.Rag.RagKnowledgeBaseUpdateResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseUpdate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseUpdate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseUpdateRequest,
  proto.Rag.RagKnowledgeBaseUpdateResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseUpdate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseUpdate,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseUpdateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseUpdate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseDocumentPageRequest,
 *   !proto.Rag.RagKnowledgeBaseDocumentPageResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseDocumentPage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseDocumentPage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseDocumentPageRequest,
  proto.Rag.RagKnowledgeBaseDocumentPageResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseDocumentPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseDocumentPageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseDocumentPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseDocumentPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseDocumentPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseDocumentPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDocumentPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDocumentPage,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseDocumentPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseDocumentPageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseDocumentPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDocumentPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDocumentPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagKnowledgeBaseDocumentDeleteRequest,
 *   !proto.Rag.RagKnowledgeBaseDocumentDeleteResponse>}
 */
const methodDescriptor_RagService_ragKnowledgeBaseDocumentDelete = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragKnowledgeBaseDocumentDelete',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagKnowledgeBaseDocumentDeleteRequest,
  proto.Rag.RagKnowledgeBaseDocumentDeleteResponse,
  /**
   * @param {!proto.Rag.RagKnowledgeBaseDocumentDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagKnowledgeBaseDocumentDeleteResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagKnowledgeBaseDocumentDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagKnowledgeBaseDocumentDeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagKnowledgeBaseDocumentDeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragKnowledgeBaseDocumentDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDocumentDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDocumentDelete,
      callback);
};


/**
 * @param {!proto.Rag.RagKnowledgeBaseDocumentDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagKnowledgeBaseDocumentDeleteResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragKnowledgeBaseDocumentDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragKnowledgeBaseDocumentDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragKnowledgeBaseDocumentDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagConversationPageRequest,
 *   !proto.Rag.RagConversationPageResponse>}
 */
const methodDescriptor_RagService_ragConversationPage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragConversationPage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagConversationPageRequest,
  proto.Rag.RagConversationPageResponse,
  /**
   * @param {!proto.Rag.RagConversationPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagConversationPageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagConversationPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagConversationPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragConversationPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragConversationPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationPage,
      callback);
};


/**
 * @param {!proto.Rag.RagConversationPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagConversationPageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragConversationPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragConversationPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagConversationCreateRequest,
 *   !proto.Rag.RagConversationCreateResponse>}
 */
const methodDescriptor_RagService_ragConversationCreate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragConversationCreate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagConversationCreateRequest,
  proto.Rag.RagConversationCreateResponse,
  /**
   * @param {!proto.Rag.RagConversationCreateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagConversationCreateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagConversationCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagConversationCreateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationCreateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragConversationCreate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragConversationCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationCreate,
      callback);
};


/**
 * @param {!proto.Rag.RagConversationCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagConversationCreateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragConversationCreate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragConversationCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationCreate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagConversationHistoryRequest,
 *   !proto.Rag.RagConversationHistoryResponse>}
 */
const methodDescriptor_RagService_ragConversationHistory = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragConversationHistory',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagConversationHistoryRequest,
  proto.Rag.RagConversationHistoryResponse,
  /**
   * @param {!proto.Rag.RagConversationHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagConversationHistoryResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagConversationHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagConversationHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragConversationHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragConversationHistory',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationHistory,
      callback);
};


/**
 * @param {!proto.Rag.RagConversationHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagConversationHistoryResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragConversationHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragConversationHistory',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationHistory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagConversationSendRequest,
 *   !proto.Rag.RagConversationSendResponse>}
 */
const methodDescriptor_RagService_ragConversationSend = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragConversationSend',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.Rag.RagConversationSendRequest,
  proto.Rag.RagConversationSendResponse,
  /**
   * @param {!proto.Rag.RagConversationSendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagConversationSendResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagConversationSendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationSendResponse>}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragConversationSend =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/Rag.RagService/ragConversationSend',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationSend);
};


/**
 * @param {!proto.Rag.RagConversationSendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationSendResponse>}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServicePromiseClient.prototype.ragConversationSend =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/Rag.RagService/ragConversationSend',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationSend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagConversationDeleteRequest,
 *   !proto.Rag.RagConversationDeleteResponse>}
 */
const methodDescriptor_RagService_ragConversationDelete = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragConversationDelete',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagConversationDeleteRequest,
  proto.Rag.RagConversationDeleteResponse,
  /**
   * @param {!proto.Rag.RagConversationDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagConversationDeleteResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagConversationDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagConversationDeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagConversationDeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragConversationDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragConversationDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationDelete,
      callback);
};


/**
 * @param {!proto.Rag.RagConversationDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagConversationDeleteResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragConversationDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragConversationDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragConversationDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelProviderPageRequest,
 *   !proto.Rag.RagModelProviderPageResponse>}
 */
const methodDescriptor_RagService_ragModelProviderPage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelProviderPage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelProviderPageRequest,
  proto.Rag.RagModelProviderPageResponse,
  /**
   * @param {!proto.Rag.RagModelProviderPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelProviderPageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelProviderPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelProviderPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelProviderPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelProviderPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelProviderPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelProviderPage,
      callback);
};


/**
 * @param {!proto.Rag.RagModelProviderPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelProviderPageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelProviderPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelProviderPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelProviderPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelPageRequest,
 *   !proto.Rag.RagModelPageResponse>}
 */
const methodDescriptor_RagService_ragModelPage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelPage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelPageRequest,
  proto.Rag.RagModelPageResponse,
  /**
   * @param {!proto.Rag.RagModelPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelPageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelPage,
      callback);
};


/**
 * @param {!proto.Rag.RagModelPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelPageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelDetailRequest,
 *   !proto.Rag.RagModelDetailResponse>}
 */
const methodDescriptor_RagService_ragModelDetail = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelDetail',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelDetailRequest,
  proto.Rag.RagModelDetailResponse,
  /**
   * @param {!proto.Rag.RagModelDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelDetailResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelDetail',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelDetail,
      callback);
};


/**
 * @param {!proto.Rag.RagModelDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelDetailResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelDetail',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelCreateRequest,
 *   !proto.Rag.RagModelCreateResponse>}
 */
const methodDescriptor_RagService_ragModelCreate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelCreate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelCreateRequest,
  proto.Rag.RagModelCreateResponse,
  /**
   * @param {!proto.Rag.RagModelCreateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelCreateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelCreateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelCreateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelCreate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelCreate,
      callback);
};


/**
 * @param {!proto.Rag.RagModelCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelCreateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelCreate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelCreate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelUpdateRequest,
 *   !proto.Rag.RagModelUpdateResponse>}
 */
const methodDescriptor_RagService_ragModelUpdate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelUpdate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelUpdateRequest,
  proto.Rag.RagModelUpdateResponse,
  /**
   * @param {!proto.Rag.RagModelUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelUpdate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelUpdate,
      callback);
};


/**
 * @param {!proto.Rag.RagModelUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelUpdateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelUpdate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagModelDeleteRequest,
 *   !proto.Rag.RagModelDeleteResponse>}
 */
const methodDescriptor_RagService_ragModelDelete = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragModelDelete',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagModelDeleteRequest,
  proto.Rag.RagModelDeleteResponse,
  /**
   * @param {!proto.Rag.RagModelDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagModelDeleteResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagModelDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagModelDeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagModelDeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragModelDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragModelDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelDelete,
      callback);
};


/**
 * @param {!proto.Rag.RagModelDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagModelDeleteResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragModelDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragModelDelete',
      request,
      metadata || {},
      methodDescriptor_RagService_ragModelDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagSharedSpacePageRequest,
 *   !proto.Rag.RagSharedSpacePageResponse>}
 */
const methodDescriptor_RagService_ragSharedSpacePage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragSharedSpacePage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagSharedSpacePageRequest,
  proto.Rag.RagSharedSpacePageResponse,
  /**
   * @param {!proto.Rag.RagSharedSpacePageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagSharedSpacePageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagSharedSpacePageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagSharedSpacePageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagSharedSpacePageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragSharedSpacePage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpacePage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpacePage,
      callback);
};


/**
 * @param {!proto.Rag.RagSharedSpacePageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagSharedSpacePageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragSharedSpacePage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpacePage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpacePage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagSharedSpaceCreateRequest,
 *   !proto.Rag.RagSharedSpaceCreateResponse>}
 */
const methodDescriptor_RagService_ragSharedSpaceCreate = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragSharedSpaceCreate',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagSharedSpaceCreateRequest,
  proto.Rag.RagSharedSpaceCreateResponse,
  /**
   * @param {!proto.Rag.RagSharedSpaceCreateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagSharedSpaceCreateResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagSharedSpaceCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagSharedSpaceCreateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagSharedSpaceCreateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragSharedSpaceCreate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceCreate,
      callback);
};


/**
 * @param {!proto.Rag.RagSharedSpaceCreateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagSharedSpaceCreateResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragSharedSpaceCreate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceCreate',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceCreate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagSharedSpaceInviteRequest,
 *   !proto.Rag.RagSharedSpaceInviteResponse>}
 */
const methodDescriptor_RagService_ragSharedSpaceInvite = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragSharedSpaceInvite',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagSharedSpaceInviteRequest,
  proto.Rag.RagSharedSpaceInviteResponse,
  /**
   * @param {!proto.Rag.RagSharedSpaceInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagSharedSpaceInviteResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagSharedSpaceInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagSharedSpaceInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagSharedSpaceInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragSharedSpaceInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceInvite',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceInvite,
      callback);
};


/**
 * @param {!proto.Rag.RagSharedSpaceInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagSharedSpaceInviteResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragSharedSpaceInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceInvite',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagSharedSpaceMemberPageRequest,
 *   !proto.Rag.RagSharedSpaceMemberPageResponse>}
 */
const methodDescriptor_RagService_ragSharedSpaceMemberPage = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragSharedSpaceMemberPage',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagSharedSpaceMemberPageRequest,
  proto.Rag.RagSharedSpaceMemberPageResponse,
  /**
   * @param {!proto.Rag.RagSharedSpaceMemberPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagSharedSpaceMemberPageResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagSharedSpaceMemberPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagSharedSpaceMemberPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagSharedSpaceMemberPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragSharedSpaceMemberPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceMemberPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceMemberPage,
      callback);
};


/**
 * @param {!proto.Rag.RagSharedSpaceMemberPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagSharedSpaceMemberPageResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragSharedSpaceMemberPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceMemberPage',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceMemberPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagSharedSpaceRemoveMemberRequest,
 *   !proto.Rag.RagSharedSpaceRemoveMemberResponse>}
 */
const methodDescriptor_RagService_ragSharedSpaceRemoveMember = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragSharedSpaceRemoveMember',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagSharedSpaceRemoveMemberRequest,
  proto.Rag.RagSharedSpaceRemoveMemberResponse,
  /**
   * @param {!proto.Rag.RagSharedSpaceRemoveMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagSharedSpaceRemoveMemberResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagSharedSpaceRemoveMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagSharedSpaceRemoveMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagSharedSpaceRemoveMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragSharedSpaceRemoveMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceRemoveMember',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceRemoveMember,
      callback);
};


/**
 * @param {!proto.Rag.RagSharedSpaceRemoveMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagSharedSpaceRemoveMemberResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragSharedSpaceRemoveMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragSharedSpaceRemoveMember',
      request,
      metadata || {},
      methodDescriptor_RagService_ragSharedSpaceRemoveMember);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Rag.RagAgentListRequest,
 *   !proto.Rag.RagAgentListResponse>}
 */
const methodDescriptor_RagService_ragAgentList = new grpc.web.MethodDescriptor(
  '/Rag.RagService/ragAgentList',
  grpc.web.MethodType.UNARY,
  proto.Rag.RagAgentListRequest,
  proto.Rag.RagAgentListResponse,
  /**
   * @param {!proto.Rag.RagAgentListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Rag.RagAgentListResponse.deserializeBinary
);


/**
 * @param {!proto.Rag.RagAgentListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.Rag.RagAgentListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Rag.RagAgentListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Rag.RagServiceClient.prototype.ragAgentList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Rag.RagService/ragAgentList',
      request,
      metadata || {},
      methodDescriptor_RagService_ragAgentList,
      callback);
};


/**
 * @param {!proto.Rag.RagAgentListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Rag.RagAgentListResponse>}
 *     Promise that resolves to the response
 */
proto.Rag.RagServicePromiseClient.prototype.ragAgentList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Rag.RagService/ragAgentList',
      request,
      metadata || {},
      methodDescriptor_RagService_ragAgentList);
};


module.exports = proto.Rag;
